import WorkspacePage from "./workspace";

export default WorkspacePage;
